var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"export"},[_c('button',{on:{"click":_vm.exportPTT}},[(_vm.reportQuestionsDownloadControl[_vm.index])?_c('span',[_c('Loader',{attrs:{"color":"#696969"}})],1):_c('DownloadFile')],1),_c('div',{staticClass:"text-hover"},[_vm._v("\n    "+_vm._s(_vm.parseTranslation(_vm.isWordCloud ? _vm.WORD_CLOUD : _vm.DOWNLOAD_CHART))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }